import * as React from "react"
import { Search, X } from "lucide-react"
import { cn } from "@/lib/utils"

interface SearchBarProps extends React.InputHTMLAttributes<HTMLInputElement> {
  onSearch: (value: string) => void
  className?: string
  value: string
  placeholder?: string
  onClear?: () => void
}

const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(
  ({ className, onSearch, value, placeholder = "Pesquisar...", onClear, ...props }, ref) => {
    return (
      <div className={cn(
        "relative flex items-center w-full",
        className
      )}>
        <Search className="absolute left-3 h-4 w-4 text-muted-foreground/70" />
        <input
          type="text"
          className={cn(
            "h-9 w-full rounded-md border border-input bg-background/95 pl-9 pr-8",
            "text-sm placeholder:text-muted-foreground/70",
            "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
            "transition-colors duration-200",
            "hover:border-[#39b92c]/30 focus:border-[#39b92c]",
            "shadow-sm backdrop-blur-sm"
          )}
          value={value}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          ref={ref}
          {...props}
        />
        {value && (
          <button
            onClick={onClear}
            className="absolute right-2 p-1 hover:bg-muted/30 rounded-sm transition-colors"
          >
            <X className="h-4 w-4 text-muted-foreground/70" />
          </button>
        )}
      </div>
    )
  }
)

SearchBar.displayName = "SearchBar"

export { SearchBar }
